import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Report } from '../../../models/report.model';
import { PervalValidators } from '../../../../shared';
import { getFirstControlErrorMessage } from '../../../../shared/utils/forms.utils';
import { MES_DETAILS_DOSSIER_EDIT_MODE_ERROR_MESSAGES } from '../../../../shared/errors/forms-errors';

@Component({
  selector: 'app-details-dossier-edit-mode',
  templateUrl: './details-dossier-edit-mode.component.html',
  styleUrls: ['./details-dossier-edit-mode.component.scss'],
})
export class DetailsDossierEditModeComponent implements OnChanges {
  @Input() detailsDossier!: Report.Case;
  @Input() errorMessage?: string | null;
  @Input() errorStatus?: number | null;

  @Output() detailsDossierChanged = new EventEmitter<Report.Case>();
  @Output() cleanError = new EventEmitter();
  @Output() formChange = new EventEmitter<boolean>();

  detailsDossierForm = new FormGroup({
    reference: new FormControl('', [
      Validators.maxLength(30),
      PervalValidators.referencesValidator,
    ]),
    date: new FormControl(''),
    address: new FormControl(''),
    connectionToTheProperty: new FormControl(''),
    purpose: new FormControl(''),
    comments: new FormControl(''),
  });

  private detailsDossierBien!: Report.Case;

  ngOnChanges(changes: SimpleChanges): void {
    const currentDetailsDossier = changes['detailsDossier']?.currentValue;
    if (currentDetailsDossier) {
      this.detailsDossierBien = currentDetailsDossier;
      this.setFormValues();
    }
  }

  referenceChanged(event: Event) {
    this.detailsDossierBien = {
      ...this.detailsDossierBien,
      reference: (event.target as HTMLInputElement).value,
    };
    if (this.errorStatus && this.errorMessage) {
      this.cleanError.emit();
    }
    this.detailsDossierChanged.emit(this.detailsDossierBien);
    this.formChange.emit(this.detailsDossierForm.valid);
  }

  dateChanged(event: Event) {
    this.detailsDossierBien = {
      ...this.detailsDossierBien,
      date: (event.target as HTMLInputElement).value,
    };

    this.detailsDossierChanged.emit(this.detailsDossierBien);
    this.formChange.emit(this.detailsDossierForm.valid);
  }

  addressChanged(event: Event) {
    this.detailsDossierBien = {
      ...this.detailsDossierBien,
      address: (event.target as HTMLInputElement).value,
    };

    this.detailsDossierChanged.emit(this.detailsDossierBien);
    this.formChange.emit(this.detailsDossierForm.valid);
  }

  connectionToThePropertyChanged(event: Event) {
    this.detailsDossierBien = {
      ...this.detailsDossierBien,
      connectionToTheProperty: (event.target as HTMLInputElement).value,
    };

    this.detailsDossierChanged.emit(this.detailsDossierBien);
    this.formChange.emit(this.detailsDossierForm.valid);
  }

  purposeChanged(event: Event) {
    this.detailsDossierBien = {
      ...this.detailsDossierBien,
      purpose: (event.target as HTMLInputElement).value,
    };

    this.detailsDossierChanged.emit(this.detailsDossierBien);
    this.formChange.emit(this.detailsDossierForm.valid);
  }

  commentsChanged(event: Event) {
    this.detailsDossierBien = {
      ...this.detailsDossierBien,
      comments: (event.target as HTMLInputElement).value,
    };

    this.detailsDossierChanged.emit(this.detailsDossierBien);
    this.formChange.emit(this.detailsDossierForm.valid);
  }

  private setFormValues(): void {
    this.detailsDossierForm.controls.reference.setValue(
      this.detailsDossier.reference,
    );

    this.detailsDossierForm.controls.date.setValue(this.detailsDossier.date);

    this.detailsDossierForm.controls.address.setValue(
      this.detailsDossier.address,
    );

    this.detailsDossierForm.controls.connectionToTheProperty.setValue(
      this.detailsDossier.connectionToTheProperty,
    );

    this.detailsDossierForm.controls.purpose.setValue(
      this.detailsDossier.purpose,
    );

    this.detailsDossierForm.controls.comments.setValue(
      this.detailsDossier.comments,
    );
    this.formChange.emit(this.detailsDossierForm.valid);
  }

  public onNotificationClick() {
    this.cleanError.emit();
  }

  public getErrorMessage(
    controlName: keyof typeof MES_DETAILS_DOSSIER_EDIT_MODE_ERROR_MESSAGES,
  ): string {
    const control = this.detailsDossierForm.controls[controlName];

    if (!control.touched) {
      return '';
    }

    return getFirstControlErrorMessage(
      this.detailsDossierForm.controls[controlName],
      MES_DETAILS_DOSSIER_EDIT_MODE_ERROR_MESSAGES[controlName],
    );
  }
}
